import GalleryModal from "@@components/gallery-modal/GalleryModal";
import useItemDetailsContext from "@@pages/item-details/hooks/useItemDetailsContext";

const PhotosTab: React.FC = () => {
  const { itemDetails } = useItemDetailsContext();
  return (
    <GalleryModal isGalleryInPage={true} itemId={itemDetails.id as string} />
  );
};

export default PhotosTab;
